import { TagDTO } from '@forto-dev/booking-v2-api'
import { ISOIncotermCode } from '@freighthub/freighthub-purchase-order-management-client'
import { BillingAddressType } from 'features/Billing'
import {
  BookingParty,
  BuyersConsolidationQuoteServicesJSON,
  Cargo,
  Currency,
  CustomsBondType,
  CustomsType,
  IInsurance,
  IQuoteOption,
  LineItemInterface,
} from 'features/BookingFlow'
import { PortOrAddress } from 'features/Directory'
import { DocumentInterface } from 'features/Documents'
import { ShipmentTradelane } from 'features/ShipmentsList'
import { ITransportPlan2 } from 'features/TransportPlan'
import { clone, merge } from 'lodash-es'

import { HaulageDetails } from './HaulageDetails'
import { RequiredAction } from './RequiredActions'
import { ShipmentIncident } from './ShipmentIncident'

export interface IContact {
  _id?: string
  companyName?: string
  contactPerson?: string
  address?: string
  phone?: string
  email?: string
  externalId?: string
  pickupAddress?: string
  contactID?: string
  legalEntityID?: string
}

export interface IShipperContact extends IContact {}

export interface IRequiredAction {
  // This is optional for backward compatibility
  completed?: boolean
  type: string
  i18n: {
    term: string
    params?: { [key in string]: string | number }
  }
}

type TShipmentState = 'new' | 'active' | 'completed' | 'closed' | 'canceled'

export type ShipmentMode = 'sea' | 'air' | 'seaAir' | 'rail'
export type ShipmentType = 'fcl' | 'lcl'

export interface TagInterface {
  _id: number | undefined
  key: string
  value: string
}

interface AdditionalCharge {
  type: AdditionalChargeType
  message: string
}
type AdditionalChargeType = 'customsCapitalProvisioning'
type ShipmentHblType = 'original' | 'express'

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export type CarbonOffset = {
  offsetStrategy: 'all' | 'none'
}

type OpsData = {
  class: ShipmentTradelane
  star: boolean
}

export abstract class ShipmentInterface {
  // @ts-expect-error TS(2564) FIXME: Property '_id' has no initializer and is not defin... Remove this comment to see the full error message
  _id: string
  booking_id?: string
  // @ts-expect-error TS(2564) FIXME: Property 'additionalCharges' has no initializer an... Remove this comment to see the full error message
  additionalCharges: AdditionalCharge[]
  // @ts-expect-error TS(2564) FIXME: Property 'additionalInformation' has no initialize... Remove this comment to see the full error message
  additionalInformation: string
  // @ts-expect-error TS(2564) FIXME: Property 'billingAddress' has no initializer and i... Remove this comment to see the full error message
  billingAddress: BillingAddressType
  // @ts-expect-error TS(2564) FIXME: Property 'bookingNumber' has no initializer and is... Remove this comment to see the full error message
  bookingNumber: string
  // @ts-expect-error TS(2564) FIXME: Property 'cargo' has no initializer and is not def... Remove this comment to see the full error message
  cargo: Cargo[]
  carbonOffset?: CarbonOffset
  // @ts-expect-error TS(2564) FIXME: Property 'cargoStackable' has no initializer and i... Remove this comment to see the full error message
  cargoStackable: boolean
  // @ts-expect-error TS(2564) FIXME: Property 'consigneeContact' has no initializer and... Remove this comment to see the full error message
  consigneeContact: IContact
  // @ts-expect-error TS(2564) FIXME: Property 'containers' has no initializer and is no... Remove this comment to see the full error message
  containers: Container[]
  // @ts-expect-error TS(2564) FIXME: Property 'createdAt' has no initializer and is not... Remove this comment to see the full error message
  createdAt: string
  currentQuoteOption?: DeepPartial<IQuoteOption>
  customerReference?: string
  customsBondType?: CustomsBondType
  // @ts-expect-error TS(2564) FIXME: Property 'customer_id' has no initializer and is n... Remove this comment to see the full error message
  customer_id: string
  customsIssuance?: boolean
  // @ts-expect-error TS(2564) FIXME: Property 'customsType' has no initializer and is n... Remove this comment to see the full error message
  customsType: CustomsType
  dangerousGoods?: boolean
  // @ts-expect-error TS(2564) FIXME: Property 'deliveryDate' has no initializer and is ... Remove this comment to see the full error message
  deliveryDate: Date
  // @ts-expect-error TS(2564) FIXME: Property 'deliveryDetails' has no initializer and ... Remove this comment to see the full error message
  deliveryDetails: HaulageDetails
  // @ts-expect-error TS(2564) FIXME: Property 'destination' has no initializer and is n... Remove this comment to see the full error message
  destination: PortOrAddress
  destinationCustomsType?: CustomsType
  // @ts-expect-error TS(2564) FIXME: Property 'documents_id' has no initializer and is ... Remove this comment to see the full error message
  documents_id: string[]
  // @ts-expect-error TS(2564) FIXME: Property 'documents' has no initializer and is not... Remove this comment to see the full error message
  documents: DocumentInterface[]
  // @ts-expect-error TS(2564) FIXME: Property 'eoriNumber' has no initializer and is no... Remove this comment to see the full error message
  eoriNumber: string
  goodsValue?: Currency
  // @ts-expect-error TS(2564) FIXME: Property 'hblNumber' has no initializer and is not... Remove this comment to see the full error message
  hblNumber: string
  hblType?: ShipmentHblType
  // @ts-expect-error TS(2564) FIXME: Property 'hsCodesCount' has no initializer and is ... Remove this comment to see the full error message
  hsCodesCount: number
  // @ts-expect-error TS(2564) FIXME: Property 'incoTerms' has no initializer and is not... Remove this comment to see the full error message
  incoTerms: ISOIncotermCode
  // @ts-expect-error TS(2564) FIXME: Property 'insurance' has no initializer and is not... Remove this comment to see the full error message
  insurance: IInsurance[]
  buyersConsolidation?: BuyersConsolidationQuoteServicesJSON
  // @ts-expect-error TS(2564) FIXME: Property 'isDemo' has no initializer and is not de... Remove this comment to see the full error message
  isDemo: boolean
  // @ts-expect-error TS(2564) FIXME: Property 'isStackable' has no initializer and is n... Remove this comment to see the full error message
  isStackable: boolean
  // @ts-expect-error TS(2564) FIXME: Property 'legalEntityId' has no initializer and is... Remove this comment to see the full error message
  legalEntityId: string
  // @ts-expect-error TS(2564) FIXME: Property 'lineItems' has no initializer and is not... Remove this comment to see the full error message
  lineItems: LineItemInterface[]
  // @ts-expect-error TS(2564) FIXME: Property 'mblNumber' has no initializer and is not... Remove this comment to see the full error message
  mblNumber: string
  // @ts-expect-error TS(2564) FIXME: Property 'mode' has no initializer and is not defi... Remove this comment to see the full error message
  mode: ShipmentMode
  numberOfPackages?: number
  opsAdditionalInformation?: string
  opsData?: OpsData
  // @ts-expect-error TS(2564) FIXME: Property 'origin' has no initializer and is not de... Remove this comment to see the full error message
  origin: PortOrAddress
  originCustomsType?: CustomsType
  // @ts-expect-error TS(2564) FIXME: Property 'packingLists' has no initializer and is ... Remove this comment to see the full error message
  packingLists: PackingList[]
  // @ts-expect-error TS(2564) FIXME: Property 'packingListsCopy' has no initializer and... Remove this comment to see the full error message
  packingListsCopy: Array<number | boolean>
  // @ts-expect-error TS(2564) FIXME: Property 'pickupDetails' has no initializer and is... Remove this comment to see the full error message
  pickupDetails: HaulageDetails
  // @ts-expect-error TS(2564) FIXME: Property 'quoteOption' has no initializer and is n... Remove this comment to see the full error message
  quoteOption: IQuoteOption
  // @ts-expect-error TS(2564) FIXME: Property 'quoteSheetId' has no initializer and is ... Remove this comment to see the full error message
  quoteSheetId: string
  // @ts-expect-error TS(2564) FIXME: Property 'requiredActions' has no initializer and ... Remove this comment to see the full error message
  requiredActions: RequiredAction[]
  // @ts-expect-error TS(2564) FIXME: Property 'shipperContact' has no initializer and i... Remove this comment to see the full error message
  shipperContact: IContact
  shipmentIncidents?: ShipmentIncident[]
  // @ts-expect-error TS(2564) FIXME: Property 'specialEquipment' has no initializer and... Remove this comment to see the full error message
  specialEquipment: boolean
  // @ts-expect-error TS(2564) FIXME: Property 'state' has no initializer and is not def... Remove this comment to see the full error message
  state: TShipmentState
  // @ts-expect-error TS(2564) FIXME: Property 'totalEUR' has no initializer and is not ... Remove this comment to see the full error message
  totalEUR: number
  // @ts-expect-error TS(2564) FIXME: Property 'type' has no initializer and is not defi... Remove this comment to see the full error message
  type: ShipmentType
  vgm?: boolean
  volume?: number
  weight?: number
  bookedByFreightHub?: boolean
  bookingParty?: BookingParty
  isBookingPartyAgent?: boolean
  tp?: ITransportPlan2
  // @ts-expect-error TS(2564) FIXME: Property 'tags' has no initializer an... Remove this comment to see the full error message
  tags: TagInterface[] | TagDTO[]
}

export type ShipmentRequestBody = Partial<ShipmentInterface> & {
  transportScheme: ITransportPlan2 | undefined
}

export interface Container {
  _id: string
  type: string
  containerNumber: string
  sealNumber?: string
  netWeight?: number
  grossWeight?: number
  customerReference?: string
}

type PackagingType = 'box' | 'crate' | 'pallet' | 'carton'
export interface PackingListItem {
  description: string
  hsCode: string
  packaging: PackagingType
  quantity: number
  value?: Currency
}
type PackingList = PackingListItem[]

const PackingItemDefaults = {
  description: '',
  packaging: 'crate',
  quantity: 1,
  hsCode: '',
  value: {
    code: 'EUR',
    value: 0,
  },
}

export const createPackingItem = (item?: PackingListItem): PackingListItem => {
  const _item = {} as PackingListItem
  merge(_item, PackingItemDefaults, item)
  if (_item.value === null) {
    _item.value = clone(PackingItemDefaults.value)
  }
  return _item
}

export type THblType = 'original' | 'express'
